<template>
	<error :code="404" message="Nie znaleziono strony" />
</template>

<script>
import Error from '@/components/Error'
export default {
	components: {
		Error
	}
}
</script>